module.exports = __webpack_public_path__ + "img/carousel-photo03.972393e3.jpg";